import { render, staticRenderFns } from "./tempKGTKhas.vue?vue&type=template&id=660eb3ae&"
import script from "./tempKGTKhas.vue?vue&type=script&lang=js&"
export * from "./tempKGTKhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports